<template>
  <b-modal
    v-model="showModal"
    hide-footer
    :title="title"
    class="modal-page-custom"
    body-class="p-0"
    scrollable
    centered
    size="xl"
    @hidden="hiddenHandle"
  >
    <div class="modal-body border-top" style="max-height: 60vh">
      <div
        class="fs-16 pb-2 mb-2"
        style="box-shadow: 0 1px 0px rgba(56, 65, 74, 0.15)"
      >
        行业与应用配置
      </div>
      <el-form :model="form" :rules="rules" ref="formRef" label-width="200px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="行业" prop="industry">
              <el-select
                v-model="form.industry"
                placeholder="请选择行业"
                required
                :filterable="true"
              >
                <el-option
                  v-for="item in industryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
                <!-- 添加更多选项 -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2"> </el-col>
          <el-col :span="11">
            <el-form-item label="应用" prop="use">
              <el-select
                v-model="form.use"
                placeholder="请选择应用"
                :filterable="true"
                required
              >
                <el-option
                  v-for="item in applyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
                <!-- 添加更多选项 -->
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div
          class="fs-16 pb-2 mb-2 mt-4"
          style="box-shadow: 0 1px 0px rgba(56, 65, 74, 0.15)"
        >
          场景配置
        </div>

        <el-form-item prop="is_offline_data">
          <template #label>
            <el-switch
              class="me-2"
              @change="changeSwitch($event)"
              v-model="form.is_offline_data"
            ></el-switch
            >{{ form.is_offline_data ? "离线数据" : "在线数据" }}
          </template>
        </el-form-item>
        <el-form-item prop="is_upgrade">
          <template #label>
            <el-switch
              class="me-2"
              :disabled="
                (form &&
                  form.files &&
                  form.files.before &&
                  form.files.before.length > 0) ||
                (form &&
                  form.files &&
                  form.files.after &&
                  form.files.after.length > 0) ||
                (form &&
                  form.files &&
                  form.files.actual &&
                  form.files.actual.length > 0)
              "
              v-model="form.is_upgrade"
            ></el-switch>
            {{ form.is_upgrade ? "技改" : "非技改" }}
          </template>
        </el-form-item>
        <!-- <el-form-item label="技改" prop="is_upgrade">
          <el-switch v-model="form.is_upgrade"></el-switch>
        </el-form-item> -->

        <el-form-item v-if="form && form.is_upgrade">
          <template #label>
            <el-select
              v-model="upgrade_type"
              placeholder="请选择技改前"
              required
              :disabled="!form.is_offline_data"
            >
              <el-option :label="$t('技改前')" :value="1"></el-option>
              <el-option :label="$t('实际数据')" :value="2"></el-option>
            </el-select>
          </template>
        </el-form-item>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header d-flex align-items-center">
                <h4 class="card-title mb-0">{{ $t("历史电流数据导入") }}</h4>
              </div>
              <div class="card-body pt-0 position-relative">
                <div
                  v-if="!form.is_upgrade && !form.is_offline_data"
                  class="overlay"
                ></div>
                <equipment-database
                  :upgrade_type="upgrade_type"
                  :is_upgrade="form.is_upgrade"
                  :energy="form"
                  @energyChange="energyChange"
                  :disabled_type="!form.is_upgrade && !form.is_offline_data"
                ></equipment-database>
                <!-- :disabled_type="!form.is_upgrade&&!form.is_offline_data" -->
              </div>
            </div>
          </div>
        </div>
        <div
          class="fs-16 pb-2 mb-2 mt-4"
          style="box-shadow: 0 1px 0px rgba(56, 65, 74, 0.15)"
        >
          计算参数配置
        </div>

        <el-form-item
          v-if="form.industry == '电力' && form.use === '凝汽器抽真空'"
          required
        >
          <template #label> 电厂平均负荷L(MW) </template>
          <el-row>
            <el-col :span="24">
              <el-row>
                <el-col :span="11">
                  <el-form-item prop="cal_config.电厂平均负荷.技改前机组容量">
                    <el-input
                      type="number"
                      v-model.number="
                        form.cal_config['电厂平均负荷']['技改前机组容量']
                      "
                      placeholder=""
                    >
                      <template #prepend>技改前机组容量</template>
                    </el-input></el-form-item
                  >
                </el-col>
               
                <el-col :span="2" class="text-center">✖️</el-col>
                <el-col :span="11">
                  <el-form-item prop="cal_config.电厂平均负荷.技改前平均负荷率"
                    ><el-input
                      type="number"
                      v-model.number="
                        form.cal_config['电厂平均负荷']['技改前平均负荷率']
                      "
                      placeholder=""
                    >
                      <template #append>平均负荷率</template>
                    </el-input></el-form-item
                  >
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24" class="mt-3">
              <el-row>
                <el-col :span="11">
                  <el-form-item prop="cal_config.电厂平均负荷.技改后机组容量">
                    <el-input
                      type="number"
                      v-model.number="
                        form.cal_config['电厂平均负荷']['技改后机组容量']
                      "
                      placeholder=""
                    >
                      <template #prepend>技改后机组容量</template>
                    </el-input></el-form-item
                  >
                </el-col>
                <el-col :span="2" class="text-center">✖️</el-col>
                <el-col :span="11">
                  <el-form-item prop="cal_config.电厂平均负荷.技改后平均负荷率"
                    ><el-input
                      type="number"
                      v-model.number="
                        form.cal_config['电厂平均负荷']['技改后平均负荷率']
                      "
                      placeholder=""
                    >
                      <template #append>平均负荷率</template>
                    </el-input></el-form-item
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item prop="cal_config.日运行时长">
          <template #label>
            <div class="d-flex align-items-center">
              <div>日运行时长</div>
              <el-tooltip placement="top" effect="light" :teleported="false">
                <template #content>
                  <div style="width: 100px">
                    设备平均每日累计运行时间，以小时为单位，用于离线导入电流时能耗计算。
                  </div>
                </template>
                <img
                  style="width: 13px; height: 15px"
                  class="ms-2"
                  src="./badge.png"
                  alt="#"
                />
              </el-tooltip>
            </div>
          </template>
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
              :disabled="!form.is_offline_data"
                type="number"
                v-model.number="form.cal_config['日运行时长']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>

        <el-form-item
          v-if="form.industry == '电力' && form.use === '凝汽器抽真空'"
          label="平均背压（kPa）"
          prop="cal_config.平均背压.技改前"
        >
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['平均背压']['技改前']"
                placeholder=""
                ><template #prepend>技改前</template></el-input
              ></el-col
            >
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['平均背压']['技改后']"
                placeholder=""
                ><template #prepend>技改后</template></el-input
              ></el-col
            >
          </el-row>
        </el-form-item>

        <el-form-item label="电压U（KV）" prop="cal_config.电压">
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['电压']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="功率因数" prop="cal_config.功率因数">
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['功率因数']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>

        <el-form-item
          label="三相电路计算的常数因子"
          prop="cal_config.三相电路计算的常数因子"
        >
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['三相电路计算的常数因子']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="今日电价（元/kWh）" prop="cal_config.今日电价">
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['今日电价']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>

        <el-form-item
          label="每度电的煤耗（g/kWh）"
          prop="cal_config.每度电的煤耗"
        >
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['每度电的煤耗']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>

        <el-form-item
          v-if="form.industry == '电力' && form.use === '凝汽器抽真空'"
          label="今日煤价（元/t）"
          prop="cal_config.今日煤价"
        >
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['今日煤价']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>

        <el-form-item prop="cal_config.二氧化碳价格">
          <template #label> 二氧化碳交易价格（元/t） </template>
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['二氧化碳价格']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>

        <el-form-item
          label="预测性维护节省收益（万元/年）"
          prop="cal_config.预测性维护节省收益"
        >
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.cal_config['预测性维护节省收益']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>
        <div
          v-if="form.industry == '电力' && form.use === '凝汽器抽真空'"
          class="fs-16 pb-2 mb-2 pt-4"
          style="box-shadow: 0 1px 0px rgba(56, 65, 74, 0.15)"
        >
          节水收益
        </div>

        <el-form-item
          v-if="form.industry == '电力' && form.use === '凝汽器抽真空'"
          label="空冷"
          prop="water_config.空冷"
        >
          <el-switch v-model="form.water_config['空冷']"></el-switch>
        </el-form-item>

        <el-form-item
          v-if="form.industry == '电力' && form.use === '凝汽器抽真空'&&form.water_config['空冷']"
          prop="water_config.平均回收水流量"
        >
          <template #label>
            <div class="d-flex align-items-center">
              <div>平均回收水流量（m³/h）</div>
              <el-tooltip placement="top" effect="light" :teleported="false">
                <template #content>
                  <div>
                    <div class="fs-16 mb-1">
                      机组容量与平均回收水流量关系参考标准
                    </div>
                    <table class="table table-nowrap table-border table-hover align-middle">
                      <thead class="text-muted table-light">
                        <tr>
                          <th>机组容量（MW）</th>
                          <th>平均回收水流量（m³/h）</th>
                        </tr>
                      </thead>
                      <tbody class="list">
                        <tr>
                          <td>150</td>
                          <td>0.5</td>
                        </tr>
                        <tr>
                          <td>300</td>
                          <td>1</td>
                        </tr>
                        <tr>
                          <td>600</td>
                          <td>2</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
                <img
                  style="width: 13px; height: 15px"
                  class="ms-2"
                  src="./badge.png"
                  alt="#"
                />
              </el-tooltip>
            </div>
          </template>
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.water_config['平均回收水流量']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>

        <el-form-item
          v-if="form.industry == '电力' && form.use === '凝汽器抽真空'&&form.water_config['空冷']"
          label="水费单价（元/m³）"
          prop="water_config.水费单价"
        >
          <el-row class="w-100">
            <el-col :span="11">
              <el-input
                type="number"
                v-model.number="form.water_config['水费单价']"
                placeholder=""
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="modal-footer v-modal-footer"
      style="padding-right: 20px; padding-bottom: 20px"
    >
      <b-button type="button" variant="light" @click="hiddenHandle">{{
        $t("base.cancel")
      }}</b-button>
      <b-button type="button" variant="primary" @click="handleSubmit">{{
        $t("base.done")
      }}</b-button>
    </div>
  </b-modal>
</template>
<script>
import EquipmentDatabase from "@/views/dashboard/devices/other_page/components/equipmentDatabase";
import { postEnergyConfig, getEnergyConfig } from "@/service";

export default {
  emits: ["refresh"],
  props: {
    industryOptions: {
      type: Array,
      default: () => [],
    },
    applyOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      title: "能耗参数配置",
      showModal: false,
      upgrade_type: 1,
      form: {
        industry: "",
        use: "",
        is_offline_data: false,
        is_upgrade: false,
        cal_config: {
          电压: 0.38,
          日运行时长: "",
          功率因数: 0.8,
          三相电路计算的常数因子: 1.732,
          今日电价: 0.6,
          每度电的煤耗: 325,
          二氧化碳价格: 69.36,
          预测性维护节省收益: "",
          电厂平均负荷: {
            技改前机组容量: "",
            技改前平均负荷率: "",
            技改后机组容量: "",
            技改后平均负荷率: "",
          },
          平均背压: {
            技改前: "",
            技改后: "",
          },
          今日煤价: "",
        },
        water_config: {
          空冷: true,
          平均回收水流量: "",
          水费单价: 12.6,
        },
        files: {},
      },
    };
  },
  components: {
    EquipmentDatabase,
  },
  computed: {
    rules() {
      return this.form.industry == "电力" && this.form.use === "凝汽器抽真空"
        ? {
            industry: [
              { required: true, message: "请输入行业", trigger: "change" },
            ],
            use: [{ required: true, message: "请输入应用", trigger: "change" }],
            "cal_config.电压": [
              { required: true, message: "请输入电压", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.日运行时长": [
              { required: this.form.is_offline_data, message: "请输入日运行时长", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.功率因数": [
              { required: true, message: "请输入功率因数", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.三相电路计算的常数因子": [
              {
                required: true,
                message: "请输入三相电路计算的常数因子",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.今日电价": [
              { required: true, message: "请输入今日电价", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.每度电的煤耗": [
              {
                required: true,
                message: "请输入每度电的煤耗",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.二氧化碳价格": [
              {
                required: true,
                message: "请输入二氧化碳价格",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.预测性维护节省收益": [
              {
                required: true,
                message: "请输入预测性维护节省收益",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.电厂平均负荷.技改前机组容量": [
              {
                required: true,
                message: "请输入技改前机组容量",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.电厂平均负荷.技改前平均负荷率": [
              {
                required: true,
                message: "请输入技改前平均负荷率",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.电厂平均负荷.技改后机组容量": [
              {
                required: true,
                message: "请输入技改后机组容量",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.电厂平均负荷.技改后平均负荷率": [
              {
                required: true,
                message: "请输入技改后平均负荷率",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.平均背压.技改前": [
              {
                required: true,
                message: "请输入技改前平均背压",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.平均背压.技改后": [
              {
                required: true,
                message: "请输入技改后平均背压",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.今日煤价": [
              { required: true, message: "请输入今日煤价", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "water_config.平均回收水流量": [
              {
                required: true,
                message: "请输入平均回收水流量",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "water_config.水费单价": [
              { required: true, message: "请输入水费单价", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
          }
        : {
            industry: [
              { required: true, message: "请输入行业", trigger: "change" },
            ],
            use: [{ required: true, message: "请输入应用", trigger: "change" }],
            "cal_config.电压": [
              { required: true, message: "请输入电压", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.日运行时长": [
              { required: this.form.is_offline_data, message: "请输入日运行时长", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.功率因数": [
              { required: true, message: "请输入功率因数", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.三相电路计算的常数因子": [
              {
                required: true,
                message: "请输入三相电路计算的常数因子",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.今日电价": [
              { required: true, message: "请输入今日电价", trigger: "blur" },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.每度电的煤耗": [
              {
                required: true,
                message: "请输入每度电的煤耗",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.二氧化碳价格": [
              {
                required: true,
                message: "请输入二氧化碳价格",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
            "cal_config.预测性维护节省收益": [
              {
                required: true,
                message: "请输入预测性维护节省收益",
                trigger: "blur",
              },
              { type: "number", message: "必须为数字", trigger: "blur" },
            ],
          };
    },
  },
  methods: {
    changeSwitch(val) {
      console.log(val);
      if (!val) {
        this.upgrade_type = 1;
        this.form.cal_config['日运行时长']=''
      }
    },
    /*能耗配置详情*/
    async energyConfigData() {
      const resp = await getEnergyConfig(this.$route.query.equip_id);
      console.log(resp);
      if (resp && resp.payload && resp.payload.cal_config) {
        this.form = resp.payload;
        this.showModal = true;
      } else {
        this.showModal = true;
      }
    },
    energyChange(item) {
      this.form.files = item;
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // 模拟保存请求
          console.log("表单数据:", this.form);

          const resp = await postEnergyConfig(
            this.$route.query.equip_id,
            this.form
          );
          if (resp) {
            this.$message.success("保存成功!");
            this.showModal = false;
            this.$emit("refresh");
          }
        } else {
          // this.$message.error("请填写必填项!");
          return false;
        }
      });
    },
    open() {
      this.energyConfigData();
    },
    hiddenHandle() {
      console.log("关闭");
      this.showModal = false;
      this.$refs.formRef.resetFields();
    },
    save() {
      console.log("save");
    },
  },
  mounted() {
    // this.energyConfigData();
  },
};
</script>

<style scoped>
/* 可根据需要添加样式 */
.modal-page-custom .el-tag {
  background: #f3f6f9 !important;
  color: #000 !important;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  pointer-events: none;
}
</style>
